export default <T>(list: Array<T>, page: number, pageSize: number = 15): [number, Array<T>] => {

// strani
    const totalPages = Math.ceil(list.length / pageSize);
    const currentPage = list.slice((page - 1) * pageSize, page * pageSize)
    return [totalPages, currentPage];
}
